import React, { Component } from 'react';
import { PhotoAlbum, ShareContent } from '.';
import InlineSVG from './InlineSVG';

export default class Content extends Component {
  render() {
    const content = JSON.parse(this.props.content);
    const regexImage = /image\//;
    const excludeContentIndexes = [];
    return (
      <div>
        {
          content.data.map((dataContent, index) => {
            if (excludeContentIndexes.indexOf(index) !== -1)
              return false;

            const { data, type } = dataContent;
            const key = `content-${index}`;
            switch (type) {
              case 'header1':
                return <h3 key={key} dangerouslySetInnerHTML={{
                  __html: data.text
                }}></h3>;
                break;
              case 'header2':
                return <h4 key={key} dangerouslySetInnerHTML={{
                  __html: data.text
                }}></h4>;
                break;
              case 'text':
                return (
                  <div key={key} dangerouslySetInnerHTML={{
                    __html: data.text
                  }}></div>
                );
                break;
              case 'list':
                return (
                  <ul key={key} className="list-benefits">
                    { data.listItems.map((item, indexItem) => (
                      <li key={`${key}-item-${indexItem}`}>
                        <img alt="" src={require("../img/icon-correct.svg")}/>
                        <span dangerouslySetInnerHTML={{
                          __html: item.content
                        }}></span>
                      </li>
                    )) }
                  </ul>
                )
                break;
              case 'image':
                const nextIndex = index + 1;
                const fileImages = [data.file];
                while(nextIndex < content.data.length) {
                  const nextContentItem = content.data[nextIndex];
                  if (nextContentItem.type !== 'image')
                    break;

                  excludeContentIndexes.push(nextIndex);
                  fileImages.push(nextContentItem.data.file);
                  nextIndex++;
                }

                if (fileImages.length === 1) {
                  const maxWidth = 890;
                  const styles = {};

                  if (window.innerWidth > (maxWidth + 40))
                    styles.maxWidth = data.file.width < maxWidth ? data.file.width : maxWidth;

                  return <img className="content-image" key={key} alt="" src={`${data.file.url}`} style={styles}/>;
                }

                return <PhotoAlbum key={key} contenKey={key} items={fileImages} />;
                break;
              case 'video':
                return <iframe key={key} src={`https://www.youtube.com/embed/${data.remote_id}?rel=0&amp;controls=1&amp;showinfo=0&amp;autoplay=0`} frameBorder="0" allowFullScreen></iframe>
                break;
              case 'button':
                return (
                  <div key={key} className="rates_button">
                    <a target="_blank" href={data.file.url} onClick={(e) => {
                        const { onOpenPhotoSwipe } = this.props;
                        if(regexImage.test(data.file.mimetype) && onOpenPhotoSwipe)
                          onOpenPhotoSwipe(e, data.file, data.caption);
                      }}>
                      <span className="icon"><InlineSVG src={require("../img/icon-arrow.svg")} /></span>
                      <span>{data.caption}</span>
                    </a>
                    { data.shared &&  <ShareContent filePath={data.file.url}/> }
                  </div>
                )
                break;
              case 'small':
                return (
                  <h5 key={key} dangerouslySetInnerHTML={{
                    __html: data.text
                  }}></h5>
                );
                break;
              default:
            }
          })
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Content.js